import React, { useState } from "react";

import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";

const DropDownGroup = (props) => {
  const { id, label, children, icon, selectMultiple } = props;
  const [show, setShow] = useState(false);

  const handleToggle = (isOpen, event, metedata) => {
    if (selectMultiple && metedata.source === "select") {
      return;
    }
    setShow(isOpen);
  };

  return (
    <Dropdown show={show} onToggle={handleToggle}>
      <Dropdown.Toggle
        id={id}
        className="map-control-dropdown-toggle d-flex justify-content-center align-items-center"
      >
        <div className="d-none d-lg-block small font-weight-bold">{label}</div>
        {icon}
      </Dropdown.Toggle>
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Dropdown>
  );
};

DropDownGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  selectMultiple: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element.isRequired),
};

export default DropDownGroup;
